<ul class="breadcrumb mat-body-2">
  @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
    <li>
      <span
        [routerLink]="breadcrumb.url"
        [ngClass]="{ 'breadcrumb-link': i !== breadcrumbs.length - 1 }"
        >{{ breadcrumb.label }}</span
        >
        @if (i !== breadcrumbs.length - 1) {
          <span>
            <span class="style-barra">{{ barra }}</span>
          </span>
        }
      </li>
    }
  </ul>
